import { render, staticRenderFns } from "./grid-view-items.vue?vue&type=template&id=9f96b396&scoped=true"
import script from "./grid-view-items.vue?vue&type=script&lang=js"
export * from "./grid-view-items.vue?vue&type=script&lang=js"
import style0 from "./grid-view-items.vue?vue&type=style&index=0&id=9f96b396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f96b396",
  null
  
)

export default component.exports